import { Partytown } from '@qwik.dev/partytown/react';

import { useMountEffect } from './hooks/useMountEffect';
import { Usetiful } from './services';

const HUBSPOT_SCRIPT_ID = 'hs-script-loader';
const HUBSPOT_SCRIPT_SRC = 'https://js.hs-scripts.com/4894764.js';
const IDLE_TIMEOUT_MS = 2000;

const runWhenIdle = (callback: () => void): (() => void) => {
	if (typeof window.requestIdleCallback === 'function') {
		const idleCallbackId = window.requestIdleCallback(callback, {
			timeout: IDLE_TIMEOUT_MS,
		});

		return () => window.cancelIdleCallback(idleCallbackId);
	}

	const timeoutId = window.setTimeout(callback, IDLE_TIMEOUT_MS);

	return () => window.clearTimeout(timeoutId);
};

const loadHubSpot = (): void => {
	if (document.getElementById(HUBSPOT_SCRIPT_ID)) {
		return;
	}

	const script = document.createElement('script');
	script.id = HUBSPOT_SCRIPT_ID;
	script.src = HUBSPOT_SCRIPT_SRC;
	script.async = true;

	document.body.appendChild(script);
};

export const Scripts = () => {
	useMountEffect(() =>
		runWhenIdle(() => {
			loadHubSpot();
			Usetiful.init();
		}),
	);

	return <Partytown debug={import.meta.env.DEV} />;
};
